
import { IProfession, ISpecialty } from "@interfaces/catalogs/education";
import { NationalityI } from "@interfaces/catalogs/profile-info";
import { ICatalogData, NewfcUserCatalogItem, fcClueCatalog, fcUserCatalogItem } from "@interfaces/fc-user/fc-user";
import catalogsApiInstance from "@services/clients/catalogs";

//#region Professions
/** Service to obtain the profession  catalog 
 * @returns Array of catalog IProfession
 */
export async function getProfessionCatalogV1() 
{
    const endpoint = "/practitioner/profession";
    const response = await catalogsApiInstance.get<IProfession[]>(endpoint);
    return response.data;
}

/** Service to obtain the speciality catalog 
 * @returns Array of catalog ISpecialty
 */
export async function getSpecialityCatalogV1() 
{
    const endpoint = "/practitioner/profession/speciality";
    const response = await catalogsApiInstance.get<ISpecialty[]>(endpoint);
    return response.data;
}
//#endregion

 /** Service to obtain the reason service catalog 
 * @returns Array of fcUserCatalogItem
 */
 export async function getReasonsServiceCatalogV1(lang: string) {
    const endpoint = "/reason/visit";
    const response = await catalogsApiInstance.get<fcUserCatalogItem[]>(endpoint,
        { headers: { Lang: `${lang}`}}
    );
    return response.data;
}

 /** Service to save new reason service to practitioner catalog
 * @param newReasonData reason Data NewfcUserCatalogItem
 * @returns return new fcUserCatalogItem
 */
export async function postNewReasonVisitV1(newReasonData: NewfcUserCatalogItem) {
    const endpoint = "/reason/visit";
    const response = await catalogsApiInstance.post<fcUserCatalogItem>(endpoint,newReasonData);
    return response.data;
}
export async function getCountriesM(lang:string) {
    const endpoint = "/practitioner/country";
    const response = await catalogsApiInstance.get<NationalityI[]>(endpoint,
        { headers: { Lang: `${lang}`}}
    );
    return response.data;
}
export async function getCluesCatalog(stateCode?:string, search?:string) {
    let endpoint = "health/establishments/clues"; 
    const params = new URLSearchParams();
    if(stateCode)
        params.append("idEntidadFederativa", String(stateCode));
    if(search)
        params.append("search", String(search));
    const strParams = params.toString();
    if(strParams)
        endpoint += `?${strParams}`;
    const response = await catalogsApiInstance.get<fcClueCatalog[]>(endpoint);
    return response.data;
}
export async function getBiologicalGenderCatalog(lang:string) {
    const endpoint = "/biological/gender";
    const response = await catalogsApiInstance.get<ICatalogData[]>(endpoint,
        { headers: { Lang: `${lang}`}}
    );
    return response.data;
}
export async function getCurpGenderCatalog(lang:string) {
    const endpoint = "/curp/gender";
    const response = await catalogsApiInstance.get<ICatalogData[]>(endpoint,
        { headers: { Lang: `${lang}`}}
    );
    return response.data;
}
export async function getIdentifiedGendeCatalog(lang:string) {
    const endpoint = "/identified/gender";
    const response = await catalogsApiInstance.get<ICatalogData[]>(endpoint,
        { headers: { Lang: `${lang}`}}
    );
    return response.data;
}
export async function getFcSegments(origin:string) {
    const endpoint = `/app/origin/segments/${origin}`;
    const response = await catalogsApiInstance.get<string[]>(endpoint);
    return response.data;
}